module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "border2",
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "valign": "middle"
    }
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "part1"
    }
  }), _vm._v("PART"), _c('br'), _vm._v("ONE")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "80%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_vm._v("Blessed by"), _c('br'), _vm._v("Experiences")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border",
    attrs: {
      "valign": "top"
    }
  }, [_c('h2', {
    staticClass: "h2a"
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "blockquotex"
  }, [_c('em', [_vm._v("“Clyburn,” she asked, “how did you vote in this primary?” It was quite a question. But, given the weightiness of the previous half-hour’s conversation, I was prepared. I looked at Emily, took a deep breath and said, “How could I ever look in the faces of our children and grandchildren had I not voted for Barack Obama?”")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2b3892","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01.vue
// module id = 90
// module chunks = 0